$(document).ready(function(){
	console.log('animator-2')

	$delay = 200
	$animations = $("div").find("[data-animation='scaledown'] , [data-animation='slideup']").toArray();
	$animations.reverse();

	initAnimationStates()

	checkAnimations()

	$(window).scroll(scrollHandler)

	function initAnimationStates()
	{
		for(var i = 0; i< $animations.length; i++)
		{
			switch($($animations[i]).data('animation'))
			{
				case 'scaledown':
					$($animations[i]).addClass('ani-scaledown-start')
					break;
				case 'slideup':
					$($animations[i]).addClass('ani-slideup-start')
					break;
				case 'slidedown':
					$($animations[i]).addClass('ani-slidedown-start')
					break;
			}
		}
	}

	function checkAnimations()
	{
		var que = 0;
		for(var i = $animations.length - 1; i>=0 ; i--)
		{
			
			if ( isInView($animations[i]) )
			{
				que++;

				switch($($animations[i]).data('animation'))
				{
					case 'scaledown':
						$($animations[i]).delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-scaledown-start').addClass('ani-scaledown-end')
					         $(this).dequeue()
					    });
						break;
					case 'slideup':
						$($animations[i]).delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-slideup-start').addClass('ani-slideup-end')
					         $(this).dequeue()
					    });
						break;
					case 'slidedown':
						$($animations[i]).delay($delay * (que - 1)).queue(function(){
					         $(this).removeClass('ani-slidedown-start').addClass('ani-slidedown-end')
					         $(this).dequeue()
					    });
						break;
				}
				
				$animations.splice(i,1)
			}
		}
	}

	function scrollHandler()
	{
		checkAnimations();
	}

	function isInView(elem)
	{
		var top = $(elem).offset().top
		var bottom = top + $(elem).outerHeight()
		var viewportTop = $(window).scrollTop()
		var viewportBottom = viewportTop + $(window).height() - 200

		return ( bottom > viewportTop && top < viewportBottom )
	}

});